import React from "react";
import PageHeader from "@/components/PageHeader";
import { SharedDocsList } from "@/components/documents/SharedDocsList";

export default function DocenteDocumenti() {
  return (
    <div className="p-4 sm:p-6 md:p-10 max-w-[1000px] mx-auto" data-testid="docente-documenti">
      <PageHeader
        title="Documenti"
        subtitle="Regolamenti, modulistica e calendari pubblicati dalla segreteria."
      />
      <SharedDocsList />
    </div>
  );
}
